import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import gitInfo from '../../../git-version.json';
import packageJson from '../../../../package.json';

@Component({
  selector: 'sbb-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VersionComponent implements OnInit {
  commitHash: string;
  version: string;

  ngOnInit(): void {
    console.log('gitInfo', gitInfo);
    this.commitHash = gitInfo.hash;
    this.version = packageJson.version;
  }
}
